/**
 * The number of colors in the 24-bit color format (True Color).
 * @type {number}
 * @constant
 */
const COLORS_24_BITS = Math.pow(256, 3);

/**
 * The golden ratio.
 * @type {number}
 * @constant
 */
const GOLDEN_RATIO = (Math.sqrt(5) + 1) * 0.5;

/**
 * The 8-decimals precision.
 * @type {number}
 * @constant
 */
const PRECISION_DECIMALS_8 = 8;

/**
 * The 8-decimals precision error margin (epsilon).
 * @type {number}
 * @constant
 */
const PRECISION_EPSILON_8 = Math.pow(10, - PRECISION_DECIMALS_8);

/**
 * The value to convert an angle from degrees to radians.
 * @type {number}
 * @constant
 */
const RADIANS = Math.PI / 180;

export {

    COLORS_24_BITS,
    GOLDEN_RATIO,
    PRECISION_DECIMALS_8,
    PRECISION_EPSILON_8,
    RADIANS
};
